import { ModalSpinner } from 'motion-components';
import { observer, Observer } from 'mobx-react-lite';
import React, { FC, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { Redirect, Route, Switch, useHistory, useLocation } from 'react-router-dom';
import { useRootStore } from 'store';
import styled from 'styled-components';
import Footer from './footer';
import Header from './header';
// import LoginPage from '../pages/login/login-page';
import LoginByVatPage from '../pages/login-by-vat/login-by-vat-page';
import HomePage from 'pages/home/home-page';
import { QrPage } from 'pages/qr-page/qr-page';
//import setPasswordModal from './set-password-modal';

/******************************************************************************
 * Ειδικό component για να "κρύψω" τα routes που δεν θέλω να υπάρχουν όταν
 * ο χρήστης δεν έχει κάνει ακόμα login. Στην ουσία είναι κατα συνθήκη είτε
 * Route ή Redirect στο login
 */

type Props = Route['props'] & {
  component: React.ComponentType<any>;
};

const PrivateRoute: FC<Props> = ({ component: Component, children, ...rest }) => {
  const { appStore } = useRootStore();

  return (
    <Route
      {...rest}
      render={(props) =>
        appStore.isLogIn ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

/**
 * Root entry component: if URL contains ?id=... treat it as public access and
 * redirect to `/:id` so the public `/:id` route can render without forcing login.
 */
const RootEntry: FC = () => {
  const location = useLocation();
  const { appStore } = useRootStore();
  const id = new URLSearchParams(location.search).get('id');

  if (id) {
    return <QrPage id={id} />;
  }

  return appStore.isLogIn ? <Redirect to="/home" /> : <LoginByVatPage key="login" />;
};

/**
 * Ειδικό component για να δρομολογήσω το login sto Home οταν ο χρήστης έχει κάνει login
 */
/* const PublicRoute: FC<Props> = ({ component: Component, ...rest }) => {
  const { appStore } = useRootStore();
  return <Route {...rest} render={props => (!appStore.isLogIn ? <Component {...props} /> : <Redirect to={'/'} />)} />;
}; */

/******************************************************************************
 * Βασικό route component AppRoute
 *
 * Κάθε φορά που γίνεται update το appStore το AppRoute γινεται update και δρομολογεί αναλόγως
 * την σελίδα που πρέπει. Με τον τρόπο αυτό οι σελίδες κατά κανόνα δεν χρειάζεται να ελέγχουν
 * το login/logout ή κάποιο πεδίο του appStore.
 *
 */
export const AppRoute = observer(() => {
  const { appStore } = useRootStore();
  const history = useHistory();
  const AbsoluteWrapper = styled.div``;

  useEffect(() => {
    if (appStore.userLogin.userMustChangePassword) {
      // setPasswordModal().then((res) => null);
    }
  }, [appStore.userLogin.userMustChangePassword]);

  return (
    <AbsoluteWrapper className="App">
      <div>
        <Header
          onLogoutClick={() => {
            history.push('/home');
            localStorage.clear();
            appStore.logOut();
          }}
        />{' '}
        <Container
          fluid
          className="d-flex flex-column flex-grow-1 app-main-container"
          style={{ paddingTop: 54, paddingBottom: 48 }}
        >
          <Observer>
            {() => <ModalSpinner show={appStore.busy} progress={appStore.progress} />}
          </Observer>

          <Observer>
            {() => (
              <Switch>
                <Route exact path={['/', '/login']} component={RootEntry} />

                <PrivateRoute exact path="/home" component={HomePage} />
                <PrivateRoute exact path="/home/:id" component={HomePage} />

                <Route render={() => <Redirect to="/" />} />
              </Switch>
            )}
          </Observer>
        </Container>
      </div>
      <Footer />
    </AbsoluteWrapper>
  );
});
